// extracted by mini-css-extract-plugin
module.exports = {"header":"Landing_header__Kd5rY","columnImg":"Landing_columnImg__3s0xv","dashScreenshotImg":"Landing_dashScreenshotImg__W2_0D"};